export var PeriodType;
(function (PeriodType) {
    PeriodType[PeriodType["Custom"] = 1] = "Custom";
    PeriodType[PeriodType["Day"] = 10] = "Day";
    PeriodType[PeriodType["DayTime"] = 11] = "DayTime";
    PeriodType[PeriodType["TimeOnly"] = 15] = "TimeOnly";
    PeriodType[PeriodType["Week"] = 20] = "Week";
    PeriodType[PeriodType["WeekSun"] = 21] = "WeekSun";
    PeriodType[PeriodType["WeekMon"] = 22] = "WeekMon";
    PeriodType[PeriodType["WeekTue"] = 23] = "WeekTue";
    PeriodType[PeriodType["WeekWed"] = 24] = "WeekWed";
    PeriodType[PeriodType["WeekThu"] = 25] = "WeekThu";
    PeriodType[PeriodType["WeekFri"] = 26] = "WeekFri";
    PeriodType[PeriodType["WeekSat"] = 27] = "WeekSat";
    PeriodType[PeriodType["Month"] = 30] = "Month";
    PeriodType[PeriodType["MonthYear"] = 31] = "MonthYear";
    PeriodType[PeriodType["Quarter"] = 40] = "Quarter";
    PeriodType[PeriodType["CalendarYear"] = 50] = "CalendarYear";
    PeriodType[PeriodType["FiscalYearOctober"] = 60] = "FiscalYearOctober";
    PeriodType[PeriodType["BiWeek1"] = 70] = "BiWeek1";
    PeriodType[PeriodType["BiWeek1Sun"] = 71] = "BiWeek1Sun";
    PeriodType[PeriodType["BiWeek1Mon"] = 72] = "BiWeek1Mon";
    PeriodType[PeriodType["BiWeek1Tue"] = 73] = "BiWeek1Tue";
    PeriodType[PeriodType["BiWeek1Wed"] = 74] = "BiWeek1Wed";
    PeriodType[PeriodType["BiWeek1Thu"] = 75] = "BiWeek1Thu";
    PeriodType[PeriodType["BiWeek1Fri"] = 76] = "BiWeek1Fri";
    PeriodType[PeriodType["BiWeek1Sat"] = 77] = "BiWeek1Sat";
    PeriodType[PeriodType["BiWeek2"] = 80] = "BiWeek2";
    PeriodType[PeriodType["BiWeek2Sun"] = 81] = "BiWeek2Sun";
    PeriodType[PeriodType["BiWeek2Mon"] = 82] = "BiWeek2Mon";
    PeriodType[PeriodType["BiWeek2Tue"] = 83] = "BiWeek2Tue";
    PeriodType[PeriodType["BiWeek2Wed"] = 84] = "BiWeek2Wed";
    PeriodType[PeriodType["BiWeek2Thu"] = 85] = "BiWeek2Thu";
    PeriodType[PeriodType["BiWeek2Fri"] = 86] = "BiWeek2Fri";
    PeriodType[PeriodType["BiWeek2Sat"] = 87] = "BiWeek2Sat";
})(PeriodType || (PeriodType = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
})(DayOfWeek || (DayOfWeek = {}));
export var DateToken;
(function (DateToken) {
    /** `1982, 1986, 2024` */
    DateToken["Year_numeric"] = "yyy";
    /** `82, 86, 24` */
    DateToken["Year_2Digit"] = "yy";
    /** `January, February, ..., December` */
    DateToken["Month_long"] = "MMMM";
    /** `Jan, Feb, ..., Dec` */
    DateToken["Month_short"] = "MMM";
    /** `01, 02, ..., 12` */
    DateToken["Month_2Digit"] = "MM";
    /** `1, 2, ..., 12` */
    DateToken["Month_numeric"] = "M";
    /** `1, 2, ..., 11, 12` */
    DateToken["Hour_numeric"] = "h";
    /** `01, 02, ..., 11, 12` */
    DateToken["Hour_2Digit"] = "hh";
    /** You should probably not use this. Force with AM/PM (and the good locale), not specifying this will automatically take the good local */
    DateToken["Hour_wAMPM"] = "a";
    /** You should probably not use this. Force without AM/PM (and the good locale), not specifying this will automatically take the good local */
    DateToken["Hour_woAMPM"] = "aaaaaa";
    /** `0, 1, ..., 59` */
    DateToken["Minute_numeric"] = "m";
    /** `00, 01, ..., 59` */
    DateToken["Minute_2Digit"] = "mm";
    /** `0, 1, ..., 59` */
    DateToken["Second_numeric"] = "s";
    /** `00, 01, ..., 59` */
    DateToken["Second_2Digit"] = "ss";
    /** `000, 001, ..., 999` */
    DateToken["MiliSecond_3"] = "SSS";
    /** Minimize digit: `1, 2, 11, ...` */
    DateToken["DayOfMonth_numeric"] = "d";
    /** `01, 02, 11, ...` */
    DateToken["DayOfMonth_2Digit"] = "dd";
    /** `1st, 2nd, 11th, ...` You can have your local ordinal by passing `ordinalSuffixes` in options / settings */
    DateToken["DayOfMonth_withOrdinal"] = "do";
    /** `M, T, W, T, F, S, S` */
    DateToken["DayOfWeek_narrow"] = "eeeee";
    /** `Monday, Tuesday, ..., Sunday` */
    DateToken["DayOfWeek_long"] = "eeee";
    /** `Mon, Tue, Wed, ..., Sun` */
    DateToken["DayOfWeek_short"] = "eee";
})(DateToken || (DateToken = {}));
